import React, { useCallback, useEffect, useState } from "react";
import styles from "./CompletedTasks.module.css";
import { TextField, Button, FormGroup, Box, Skeleton, Drawer, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CompletedCard from "../CompletedCard/CompletedCard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import FilterDrawer from "../../../../../components/FilterDrawer/FilterDrawer";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import { useLocation, useNavigate } from "react-router-dom";
import ClearFilter from "../../../../../components/ClearFilter/ClearFilter";
import FilterTypeWrap from "../../../../../components/FilterDrawer/FilterTypeWrap";
import FilterLabel from "../../../../../components/FilterDrawer/FilterLabel/FilterLabel";
import FilterCheckBoxWrap from "../../../../../components/FilterDrawer/FilterCheckBoxWrap";
import FilterCheckbox from "../../../../../components/FilterDrawer/FilterCheckbox/FilterCheckbox";
import FilterChipsWrap from "../../../../../components/FilterDrawer/FilterChips/FilterChipsWrap";
import FilterChips from "../../../../../components/FilterDrawer/FilterChips/FilterChips";
import getAccessStatus, {
  getSubDomainAccessStatus,
} from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import { GetTaskBoard } from "../../service/tasks.request";
import InfiniteScroll from "react-infinite-scroll-component";
import UserAvatarGroup from "../../../../../components/UserAssign/UserAvatarGroup";
import { PuffLoader } from "react-spinners";
import { resetTaskBoard, getTaskById, resetTaskById } from "../../service/tasksSlice";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import TaskDetails from "../../../../../components/TaskCreation/TaskDetails";
import {
  CreateTask,
  EditTask,
  DeleteTask,
  CreateComment,
  DeleteComment,
  EditComment,
} from "../../../Nurture/service/nurture.request";
import { resetDeleteTaskSuccess, resetEditTaskSuccess } from "../../../Nurture/service/nurtureSlice";
import { UpdateTaskStatus } from "../../service/tasks.request";

type Data = {
  instituteId: string;
  startDate: any;
  endDate: any;
  limit: number;
  userId?: any;
  branchId?: any;
  lanesToFetch?: {
    status: string;
    lastEvaluatedKey: string;
    lastEvaluatedSortKey: string;
  }[];
};

function CompletedTasks(props: any) {
  const { GetTasksByDateForAssignee, GetTasksBoard } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { userById } = useSelector((state: any) => state.userDetails);
  const { taskStatusUpdateSuccess, taskById } = useSelector((state: any) => state.tasks);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const hasAllTaskAccess = getAccessStatus(
    "TASKS",
    "ALL_OTHER_USERS'_TASK",
    userById?.rolePermission
  );

  const taskList = useSelector((state: any) => state.tasks.tasksboard);
  const { leadBoard, editTaskSuccess, deleteTaskSuccess } = useSelector((state: any) => state.nurture);
  const tasksTypes = leadBoard?.taskType;

  const taskBoardloading = useSelector(
    (state: any) => state.tasks.taskBoardloading
  );
  const employees = useSelector((state: any) => state.staff.staffList);
  const [taskItems, setTaskItems] = useState<any>();
  const [selectedTeamMember, setSelectedTeamMember] = React.useState<any>([]);
  const [hasMoreData, setHasMoreData] = useState<boolean>(true);

  const [leadSearchTerm, setLeadSearchTerm] = React.useState<any>("");

  const [selectedDate, setSelectedDate] = React.useState<number | null>(null);

  const [filterApplied, setFilterApplied] = React.useState<boolean>(false);
  const [isOpenFilter, setIsOpenFilter] = React.useState<boolean>(false);
  const [selectedGeneralTaskId, setSelectedGeneralTaskId] = useState<
    string | null
  >(null);
  const completedTasks =
    taskList && taskItems?.find((task: any) => task.stateName === "COMPLETED");

  function handleGoBack() {
    dispatch(resetTaskBoard());
    if (location?.state?.taskSelectedId) {
      navigate(`/app/Tasks?selectedUsers=${location?.state?.taskSelectedId}`);
    } else {
      navigate(`/app/Tasks`);
    }
  }

  const handleLeadSearch = (event: any) => {
    setLeadSearchTerm(event.target.value);

    const urlSearchParams = new URLSearchParams(window.location.search);

    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const taskDate = urlSearchParams.get("taskDate");
    if (userById) {
      if (taskDate && taskDate !== null) {
        const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
        const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();
        setSelectedDate(parseInt(taskDate));

        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          startDate,
          endDate,
          selectedUsersParam ? selectedUsersParam : "",
          event.target.value
        );
      } else {
        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          0,
          0,
          selectedUsersParam ? selectedUsersParam : "",
          event.target.value
        );
      }
    }
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("taskLeadSearch", event.target.value);
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
  };

  const taskBoardApiCall = useCallback(
    (
      instituteId: string,
      taskStartDate: any,
      taskEndDate: any,
      userId: any,
      searchText?: any,
      prioritiesArray?: any,
      typeArray?: any
    ) => {
      const data: any = {
        instituteId: instituteId,
        startDate: taskStartDate,
        endDate: taskEndDate,
        getTasks: true,
        entityName: "TASK",
        priority: prioritiesArray,
        taskType: typeArray,
        searchText: searchText ? searchText : "",
      };

      if (!hasAllBranchAccess) {
        data.branchId = userById?.branchId;
      }

      if (hasAllTaskAccess && userId !== "") {
        data.userId = userId;
      } else if (!hasAllTaskAccess) {
        data.userId = authUser?.institute[0]?.id;
      }

      data.lanesToFetch = [
        {
          status: "COMPLETED",
        },
      ];
      GetTasksBoard(data);
    },
    [hasAllTaskAccess, userById, hasAllBranchAccess]
  );

  const handleDateChange = (date: any) => {
    if (date !== null) {
      const dateUnix = date.unix() * 1000;
      setSelectedDate(dateUnix);

      const selectedDateFirstMinute = moment(dateUnix).startOf("day").valueOf();
      const selectedDateLastMinute = moment(dateUnix).endOf("day").valueOf();

      taskBoardApiCall(
        authUser?.institute[0]?.instituteDetails?.id,
        selectedDateFirstMinute,
        selectedDateLastMinute,
        selectedTeamMember?.length > 0 ? selectedTeamMember?.[0]?.id : ""
      );

      const queryParams = new URLSearchParams(window.location.search);
      if (dateUnix) {
        queryParams.set("taskDate", dateUnix.toString());

        const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
        window.history.pushState({}, "", newUrl);
      }
    }
  };

  const handleResetDate = useCallback(() => {
    setSelectedDate(null);
    taskBoardApiCall(
      authUser?.institute[0]?.instituteDetails?.id,
      0,
      0,
      selectedTeamMember?.length > 0 ? selectedTeamMember?.[0]?.id : ""
    );
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete("taskDate");

    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
  }, [setSelectedDate]);

  const handleNextPage = (currentLaneStatus: any) => {
    const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const taskDate = urlSearchParams.get("taskDate");

    let startingDate = null;
    let endingDate = null;
    if (taskDate && taskDate !== null) {
      startingDate = moment(parseInt(taskDate)).startOf("day").valueOf();
      endingDate = moment(parseInt(taskDate)).endOf("day").valueOf();
    } else {
      startingDate = 0;
      endingDate = 0;
    }

    const evaluatedKeysForLanes: any =
      taskItems &&
      taskItems
        ?.filter((d: any) => d?.stateName === currentLaneStatus)
        ?.map((d: any) => {
          return {
            status: currentLaneStatus,
            searchAfter: d?.tasks?.searchAfter,
          };
        });

    const data: any = {
      instituteId: userFromLocalStorage?.id,
      startDate: startingDate,
      endDate: endingDate,
      limit: 15,
      lanesToFetch: evaluatedKeysForLanes,
      getTasks: true,
      entityName: "TASK",
      priority: [],
      taskType: "",
      searchText: "",
    };
    if (!hasAllBranchAccess) {
      data.branchId = userById?.branchId;
    }
    if (hasAllTaskAccess && selectedUsersParam) {
      data.userId = selectedUsersParam;
    } else if (!hasAllTaskAccess) {
      data.userId = authUser?.institute[0]?.id;
    }

    GetTaskBoard(data).then((res: any) => {
      const result = res?.data?.data;
      const updatedState = taskItems?.map((oldObject: any) => {
        const correspondingResult = result?.find(
          (r: any) => r.stateName === oldObject.stateName
        );

        if (correspondingResult) {
          const updatedTasks = [...oldObject.tasks?.data];

          correspondingResult?.tasks?.data?.forEach((newTask: any) => {
            if (!updatedTasks?.find((task) => task.id === newTask.id)) {
              updatedTasks.push(newTask);
            }
          });

          return {
            ...oldObject,
            tasks: {
              data: updatedTasks,
              hasMore: correspondingResult?.tasks?.hasMore,
              searchAfter: correspondingResult?.tasks?.searchAfter,
            },
          };
        } else {
          return oldObject;
        }
      });
      setTaskItems(updatedState);
    });
  };

  const handleTeamMemberSelect = (emp: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskDate = urlSearchParams.get("taskDate");

    let startingDate: any | null = null;
    let endingDate: any | null = null;

    if (taskDate && taskDate !== null) {
      startingDate = moment(parseInt(taskDate)).startOf("day").valueOf();
      endingDate = moment(parseInt(taskDate)).endOf("day").valueOf();
    } else {
      startingDate = 0;
      endingDate = 0;
    }

    setSelectedTeamMember((prevSelected: any) => {
      if (prevSelected?.length > 0 && prevSelected?.[0].id === emp?.id) {
        if (startingDate !== null && endingDate !== null) {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startingDate,
            endingDate,
            ""
          );
        }

        return [];
      } else {
        if (startingDate !== null && endingDate !== null && emp?.id) {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startingDate,
            endingDate,
            emp?.id
          );
        }
        return [emp];
      }
    });

    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get("selectedUsers") === emp.id) {
      queryParams.delete("selectedUsers");
    } else {
      queryParams.set("selectedUsers", emp.id);
    }

    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
  };

  interface CheckedPriorities {
    priority: string;
  }
  interface CheckedTypes {
    type: string;
  }
  const [checkedPriorities, setCheckedPriorities] = useState<
    CheckedPriorities[]
  >([]);
  const [filterCheckedPriorities, setFilterCheckedPriorities] = useState<
    CheckedPriorities[]
  >([]);
  const [checkedTypes, setCheckedTypes] = useState<CheckedTypes[]>([]);
  const [filterCheckedTypes, setFilterCheckedTypes] = useState<CheckedTypes[]>(
    []
  );

  const handleFilterPriorityChecked = (priority: string) => {
    const priorityToAdd: CheckedPriorities = { priority };

    if (
      checkedPriorities.some(
        (item) => item.priority.toLowerCase() === priority.toLowerCase()
      )
    ) {
      setCheckedPriorities(
        checkedPriorities.filter(
          (item) => item.priority.toLowerCase() !== priority.toLowerCase()
        )
      );
    } else {
      setCheckedPriorities([...checkedPriorities, priorityToAdd]);
    }
  };

  const clearCheckedPriority = (priority: string) => {
    setCheckedPriorities(
      checkedPriorities.filter(
        (item) => item.priority.toLowerCase() !== priority.toLowerCase()
      )
    );
  };

  const handleFilterTypeChecked = (type: string) => {
    const typeToAdd: CheckedTypes = { type };

    if (
      checkedTypes.some(
        (item) => item.type.toLowerCase() === type.toLowerCase()
      )
    ) {
      setCheckedTypes(
        checkedTypes.filter(
          (item) => item.type.toLowerCase() !== type.toLowerCase()
        )
      );
    } else {
      setCheckedTypes([...checkedTypes, typeToAdd]);
    }
  };

  const clearCheckedType = (type: string) => {
    setCheckedTypes(
      checkedTypes.filter(
        (item) => item.type.toLowerCase() !== type.toLowerCase()
      )
    );
  };

  const filteredTasks =
    taskList &&
    completedTasks?.tasks?.data
      ?.filter((task: any) => {
        const isGeneralTask = task?.taskCategory?.toUpperCase() === "GENERAL_TASK";
        const searchTermMatch = isGeneralTask
          ? (task.description?.toLowerCase() || "").includes(leadSearchTerm.toLowerCase()) ||
          (task.assignedToName?.toLowerCase() || "").includes(leadSearchTerm.toLowerCase())
          : (task.studentName?.toLowerCase() || "").indexOf(leadSearchTerm.toLowerCase()) !== -1;

        const typeIsChecked =
          filterCheckedTypes.length === 0 ||
          filterCheckedTypes.some(
            (item) => item.type.toLowerCase() === (task.taskType?.toLowerCase() || "")
          );

        const priorityIsChecked =
          filterCheckedPriorities.length === 0 ||
          filterCheckedPriorities.some(
            (item) => item.priority.toLowerCase() === (task.priority?.toLowerCase() || "")
          );

        const additionalSearchTermCondition =
          task?.taskType === "DEMO" && task?.demoData?.[0]?.batchName
            ? task?.demoData?.[0]?.batchName
              .toLowerCase()
              .includes(leadSearchTerm.toLowerCase())
            : true;

        return (
          searchTermMatch &&
          typeIsChecked &&
          additionalSearchTermCondition &&
          priorityIsChecked
        );
      })
      ?.sort((a: any, b: any) => {
        const dateA = a?.date || 0;
        const dateB = b?.date || 0;
        return dateA - dateB;
      });

  const handleFilterTasks = React.useCallback(
    (typesArray: any, prioritiesArray: any) => {
      setFilterCheckedTypes(typesArray);
      setFilterCheckedPriorities(prioritiesArray);

      const urlSearchParams = new URLSearchParams(window.location.search);

      const selectedUsersParam = urlSearchParams.get("selectedUsers");
      const taskDate = urlSearchParams.get("taskDate");
      if (userById) {
        if (taskDate && taskDate !== null) {
          const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
          const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();
          setSelectedDate(parseInt(taskDate));

          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startDate,
            endDate,
            selectedUsersParam ? selectedUsersParam : "",
            "",
            prioritiesArray,
            typesArray
          );
        } else {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            0,
            0,
            selectedUsersParam ? selectedUsersParam : "",
            "",
            prioritiesArray,
            typesArray
          );
        }
      }
      const queryParams = new URLSearchParams();
      if (typesArray && typesArray.length > 0) {
        const statusParam = typesArray.map((item: any) => item.type).join("|");
        queryParams.set("completedTaskType", statusParam);
      } else {
        queryParams.delete("completedTaskType");
      }

      if (prioritiesArray && prioritiesArray.length > 0) {
        const priorityParam = prioritiesArray
          .map((item: any) => item.priority)
          .join("|");
        queryParams.set("taskPriorities", priorityParam);
      } else {
        queryParams.delete("taskPriorities");
      }

      const queryString = queryParams.toString();
      const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""
        }`;

      window.history.pushState({}, "", newUrl);
    },
    [setFilterCheckedTypes, setFilterCheckedPriorities]
  );

  const handleFilterApply = React.useCallback(() => {
    handleFilterTasks(checkedTypes, checkedPriorities);

    setFilterApplied(
      checkedPriorities?.length === 0 && checkedTypes?.length === 0
        ? false
        : true
    );
  }, [handleFilterTasks, checkedTypes, setFilterApplied, checkedPriorities]);

  const handleResetClick = React.useCallback(() => {
    handleFilterTasks([], []);
    setCheckedTypes([]);
    setCheckedPriorities([]);
    setFilterApplied(false);
  }, [
    handleFilterTasks,
    setFilterApplied,
    setCheckedTypes,
    setCheckedPriorities,
  ]);

  const handleFilterClose = React.useCallback(() => {
    setCheckedTypes(filterCheckedTypes);
    setCheckedPriorities(filterCheckedPriorities);
  }, [filterCheckedTypes, filterCheckedPriorities]);

  const cancelClick = () => {
    setIsOpenFilter(true);
  };

  const closeClearFilter = () => {
    setIsOpenFilter(false);
  };

  const yesButtonClick = () => {
    handleResetClick();
    setIsOpenFilter(false);
    setFilterApplied(false);
  };

  const noButtonClick = () => {
    setIsOpenFilter(false);
  };

  const handleTaskClick = (task: any) => {
    if (task?.taskCategory?.toUpperCase() === "GENERAL_TASK") {
      const taskId = task.id || task.activityId;
      if (taskId) {
        setSelectedGeneralTaskId(taskId);
        dispatch(getTaskById({ id: taskId, taskCategory: "GENERAL_TASK" }) as any);
      }
    }
  };

  const handleCloseDrawer = () => {
    setSelectedGeneralTaskId(null);
    dispatch(resetTaskById());
  };

  useEffect(() => {
    if (deleteTaskSuccess && deleteTaskSuccess !== false) {
      if (selectedGeneralTaskId) {
        setSelectedGeneralTaskId(null);
        dispatch(resetTaskById());
      }
      setTimeout(() => {
        dispatch(resetDeleteTaskSuccess());
      }, 100);
    }
  }, [deleteTaskSuccess, selectedGeneralTaskId, dispatch]);

  const filteredValue = (
    <>
      {filterCheckedPriorities?.length > 0 &&
        filterCheckedPriorities?.map((item) => (
          <div key={item.priority} className="filteredDiv">
            {item.priority.toLowerCase()}
          </div>
        ))}
      {filterCheckedTypes?.length > 0 &&
        filterCheckedTypes?.map((item) => (
          <div key={item.type} className="filteredDiv">
            {item.type?.toLowerCase()}
          </div>
        ))}
    </>
  );

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const typeParam = urlSearchParams.get("completedTaskType");
    const priorityParam = urlSearchParams.get("taskPriorities");

    if (priorityParam) {
      const priorities = priorityParam.split("|");

      const selectedPriorities = priorities
        .map((value) => {
          const priority = [
            { priority: "URGENT" },
            { priority: "HIGH" },
            { priority: "NORMAL" },
            { priority: "LOW" },
          ].find(
            (type: any) => type.priority.toLowerCase() === value.toLowerCase()
          );
          return priority
            ? {
              priority: priority.priority,
            }
            : null;
        })
        .filter(Boolean) as CheckedPriorities[];

      setFilterCheckedPriorities(selectedPriorities);
      setCheckedPriorities(selectedPriorities);
    }
    if (typeParam && tasksTypes) {
      const types = typeParam.split("|");

      const selectedTypes = types
        .map((value) => {
          const type = tasksTypes.find(
            (taskType: any) =>
              taskType.taskTypeName.toLowerCase() === value.toLowerCase()
          );
          return type
            ? {
              type: type.taskTypeName,
            }
            : null;
        })
        .filter(Boolean) as CheckedTypes[];

      setCheckedTypes(selectedTypes);
      setFilterCheckedTypes(selectedTypes);
    }
    if (typeParam || priorityParam) {
      setFilterApplied(true);
    }
  }, [tasksTypes]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");
    if (taskLeadSearchInUrl && taskLeadSearchInUrl !== "") {
      setLeadSearchTerm(taskLeadSearchInUrl);
    }
  }, [setSelectedDate, setLeadSearchTerm]);

  useEffect(() => {
    if (taskList) {
      setTaskItems(taskList);
    } else {
      setTaskItems([]);
    }
  }, [taskList]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    if (employees?.length > 0) {
      const staff = employees
        ?.filter((item: any) => item?.status === "ACTIVE")
        ?.find((item: any) => item.id === selectedUsersParam);
      if (staff) {
        setSelectedTeamMember([staff]);
      } else {
        setSelectedTeamMember([]);
      }
    }
  }, [employees]);

  React.useEffect(() => {
    if (Array.isArray(taskItems)) {
      const evaluatedKeysForLanes = taskItems?.map((d) => {
        return {
          status: d?.status,
          lastEvaluatedKey: d?.lastEvaluatedKey ? d?.lastEvaluatedKey : "",
          lastEvaluatedSortKey: d?.lastEvaluatedSortKey
            ? d?.lastEvaluatedSortKey
            : "",
        };
      });

      const hasEvaluatedKey = evaluatedKeysForLanes.some(
        (ds) => ds.lastEvaluatedKey !== ""
      );

      setHasMoreData(hasEvaluatedKey);
    } else {
      setHasMoreData(false);
    }
  }, [taskItems]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskDate = urlSearchParams.get("taskDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    if (userById) {
      if (taskDate && taskDate !== null) {
        const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
        const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();
        setSelectedDate(parseInt(taskDate));

        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          startDate,
          endDate,
          selectedUsersParam ? selectedUsersParam : ""
        );
      } else {
        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          0,
          0,
          selectedUsersParam ? selectedUsersParam : ""
        );
      }
    }
  }, [userById]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskDate = urlSearchParams.get("taskDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    if (taskStatusUpdateSuccess !== true && taskStatusUpdateSuccess !== false) {
      if (taskDate && taskDate !== null) {
        const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
        const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();

        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          startDate,
          endDate,
          selectedUsersParam ? selectedUsersParam : ""
        );
      } else {
        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          0,
          0,
          selectedUsersParam ? selectedUsersParam : ""
        );
      }
    }
  }, [taskStatusUpdateSuccess]);

  return (
    <div className={styles.pageWrap}>
      <div className={styles.pageWrapChild} style={{ display: "flex" }}>
        <div style={{ width: "calc( 100% - 360px)", padding: "22PX 30PX" }}>
          {completedTasks !== null ? (
            <>
              <div>
                <button
                  className={styles.completedTaskPageBackBtn}
                  onClick={handleGoBack}
                >
                  <ArrowBackIcon
                    sx={{
                      marginRight: "8px",
                      fontSize: "15PX",
                      color: "#667085",
                    }}
                  />
                  Back
                </button>
              </div>
              <h5 className={styles.completedTaskHead}>Completed tasks</h5>
              <div className={styles.completedTaskTopSplit}>
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <TextField
                      type="search"
                      value={leadSearchTerm}
                      onChange={handleLeadSearch}
                      placeholder="Search Tasks"
                      style={{
                        padding: "0px",
                        borderRadius: "4px",
                        border: "none",
                        outline: "none",
                        height: "38px",
                      }}
                      size="small"
                      inputProps={{
                        sx: {
                          width: "250px",
                          "&::placeholder": {
                            fontWeight: "400",
                            fontSize: "14px",
                          },

                          "& .MuiOutlinedInput-input": {
                            padding: "10.5px 14px",
                          },
                        },
                      }}
                    />
                    {hasAllTaskAccess && employees?.length > 0 && (
                      <UserAvatarGroup
                        handleItemSelect={handleTeamMemberSelect}
                        selectedItem={selectedTeamMember}
                      />
                    )}
                  </div>
                  <FilterDrawer
                    handleFilterApply={handleFilterApply}
                    handleResetClick={handleResetClick}
                    activeFilter={filterApplied}
                    cancelClick={cancelClick}
                    closeSetFilter={handleFilterClose}
                  >
                    <div
                      style={{
                        padding: "22px 32px",
                        overflowY: "auto",
                        maxHeight: "calc(100% - 110px)",
                      }}
                    >
                      <FilterChipsWrap>
                        {checkedPriorities.length > 0 &&
                          checkedPriorities.map((item) => (
                            <FilterChips
                              key={item.priority}
                              keyVal={item.priority}
                              chipName={item.priority.toLowerCase()}
                              clearValue={item.priority}
                              closeFunction={clearCheckedPriority}
                            />
                          ))}
                        {checkedTypes.length > 0 &&
                          checkedTypes.map((item) => (
                            <FilterChips
                              key={item.type}
                              keyVal={item.type}
                              chipName={item.type.toLowerCase()}
                              clearValue={item.type}
                              closeFunction={clearCheckedType}
                            />
                          ))}
                      </FilterChipsWrap>

                      <FilterTypeWrap>
                        <FilterLabel labelValue="Priority" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {[
                              { priority: "URGENT" },
                              { priority: "HIGH" },
                              { priority: "NORMAL" },
                              { priority: "LOW" },
                            ].map((item: any) => (
                              <FilterCheckbox
                                key={item.priority}
                                keyVal={item.priority}
                                checked={checkedPriorities.some(
                                  (data) =>
                                    data.priority.toLowerCase() ===
                                    item.priority.toLowerCase()
                                )}
                                checkboxFunction={() =>
                                  handleFilterPriorityChecked(item.priority)
                                }
                                label={item.priority.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>

                      <FilterTypeWrap>
                        <FilterLabel labelValue="Type" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {tasksTypes?.map((item: any) => (
                              <FilterCheckbox
                                key={item.id}
                                keyVal={item.id}
                                checked={checkedTypes.some(
                                  (data) =>
                                    data.type?.toLowerCase() ===
                                    item?.taskTypeName?.toLowerCase()
                                )}
                                checkboxFunction={() =>
                                  handleFilterTypeChecked(item.taskTypeName)
                                }
                                label={item?.taskTypeName?.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>
                    </div>
                  </FilterDrawer>
                </div>
              </div>
            </>
          ) : (
            <>
              <Skeleton
                animation="wave"
                variant="text"
                width="100px"
                height={15}
              />
              <Skeleton
                animation="wave"
                variant="text"
                width="200px"
                height={25}
                style={{ marginBottom: "8PX" }}
              />
              <Skeleton
                animation="wave"
                variant="rounded"
                width="99.4%"
                height={40}
                style={{ marginBottom: "15PX" }}
              />
            </>
          )}

          <div
            style={{
              maxHeight: "calc(100vh - 250px)",
              paddingRight: "5px",
              minHeight: "calc(100vh - 250px)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              position: "relative",
              overflowY: "hidden",
            }}
          >
            {completedTasks !== null && !taskBoardloading ? (
              <>
                {completedTasks && (
                  <InfiniteScroll
                    dataLength={completedTasks?.tasks?.data?.length}
                    next={() => handleNextPage(completedTasks?.stateName)}
                    hasMore={completedTasks?.tasks?.hasMore}
                    loader={
                      <Box
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {/* {<PuffLoader color="#36d7b7" />} */}
                      </Box>
                    }
                    height={"calc(100vh - 250px)"}
                  >
                    {taskList &&
                      filteredTasks?.map((task: any) => (
                        <CompletedCard
                          key={task.id}
                          taskCompletedPage={true}
                          task={task}
                          expandDisabled={false}
                          employees={employees}
                          page="COMPLETED_TASKS"
                          onTaskClick={handleTaskClick}
                        />
                      ))}
                  </InfiniteScroll>
                )}
                {taskList && filteredTasks && filteredTasks?.length === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#667085",
                        textTransform: "capitalize",
                      }}
                    >
                      No data available
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                {Array.from(new Array(4)).map((_, index) => (
                  <div
                    key={index}
                    className={styles.tableSkeletonBodyItem}
                    style={{ marginBottom: "10px" }}
                  >
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      width="100%"
                      height={100}
                    />
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
        <div
          style={{ width: "360px", borderLeft: "1px solid #E9E9E9" }}
          className="datepicker-container"
        >
          {taskList ? (
            <>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticDatePicker
                  value={dayjs(selectedDate)}
                  onChange={(date: any) => handleDateChange(date)}
                  displayStaticWrapperAs="desktop"
                  disableFuture
                />
              </LocalizationProvider>
              {selectedDate !== null && (
                <div
                  style={{
                    margin: "0 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginBottom: "20px",
                    width: "310px",
                  }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleResetDate}
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                    size="small"
                  >
                    Reset Date
                  </Button>
                </div>
              )}
            </>
          ) : (
            <>
              <div style={{ padding: "10px" }}>
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height="40px"
                  style={{
                    borderRadius: "3px",
                    marginBottom: "10px",
                  }}
                />
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height="290px"
                  style={{
                    borderRadius: "3px",
                  }}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <ClearFilter
        open={isOpenFilter}
        noButtonClick={noButtonClick}
        yesButtonClick={yesButtonClick}
        onClose={closeClearFilter}
        filteredValue={filteredValue}
      />

      <Drawer
        anchor="right"
        open={!!selectedGeneralTaskId}
        onClose={handleCloseDrawer}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: "380px", md: "500px" },
            backgroundColor: "#FFF",
          },
        }}
        sx={{ zIndex: 9 }}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#FFF",
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: "1px solid #E9E9E9",
            }}
          >
            <Typography
              variant="h6"
              component="h2"
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#101828",
              }}
            >
              {taskById?.taskTitle || "Task Details"}
            </Typography>
            <IconButton
              onClick={handleCloseDrawer}
              size="small"
              sx={{
                position: "absolute",
                left: "16px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#000000",
                padding: "4px",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
                borderRadius: "5px",
                zIndex: 999,
                backgroundColor: "#fff",
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              padding: "0",
            }}
          >
            {selectedGeneralTaskId && (
              <TaskDetails
                initialTaskId={selectedGeneralTaskId}
                tasks={taskList}
                DeleteTask={DeleteTask}
                UpdateTaskStatus={UpdateTaskStatus}
                selectedLeadData={null}
                employees={employees}
                CreateComment={CreateComment}
                DeleteComment={DeleteComment}
                EditComment={EditComment}
                EditTask={EditTask}
                CreateTask={CreateTask}
                taskTypes={tasksTypes}
                setFromTaskEdit={() => { }}
                setTaskForEditing={() => { }}
                setShowAddTask={() => { }}
                showAddTask={false}
                isInDrawer={true}
                onCloseDrawer={handleCloseDrawer}
              />
            )}
          </Box>
        </Box>
      </Drawer>
    </div>
  );
}

export default CompletedTasks;
